export default {
  created_date: 'добавлено',
  updated_date: 'изменено',
  videos_count: 'видео',
  clusters_count: 'кластеры',
  participants_count: 'участники',
  status: 'статус',
  creator: 'создатель'
};
